<template>
    <common-dropdown :isOpen="true" :hasArrow="false" arrowPositionY="bottom" arrowPositionX="right">
        <common-progress :percentage="profilePercentage" :isBarHidden="false" :isRounded="false"></common-progress>

        <common-content-spacer class="complete-profile-reminder__rating" height="micro">
            <div style="positon: relative">
                <div class="complete-profile-reminder__circle"></div>
                <b class="complete-profile-reminder__rating-text-bold">
                    {{ $t('elements.home.practice_reminder.create_company_info') }}
                </b>
            </div>
            <div class="complete-profile-reminder__rating-text">
                <router-link :to="{ name: 'company.create' }" class="complete-profile-reminder__rating-link">
                    {{ $t('elements.home.practice_reminder.create_company') }}
                </router-link>
            </div>
        </common-content-spacer>
    </common-dropdown>
</template>

<script>
    export default {
        data() {
            return {
                profilePercentage: 80,
            }
        },
    }
</script>
